






import { Component, Prop, Vue } from 'vue-property-decorator';
import * as def from '@/definitions'

@Component({
    components: {
    },
})

export default class TrimHandleBottomLeft extends Vue 
{
    @Prop() private x! : number;
    @Prop() private y! : number;
    @Prop() private width! : number;
    @Prop() private height! : number;
    @Prop() private transform! : string;

    private get points()
    {
        var pts = "";

        var left = this.x - this.width / 2;
        var bottom = this.y + this.height / 2;
        pts += left + "," + bottom + " ";
        pts += left + "," + (bottom - this.height * 3) + " ";
        pts += (left + this.width) + "," + (bottom - this.height * 3) + " ";
        pts += (left + this.width) + "," + (bottom - this.height) + " ";
        pts += (left + this.width * 3) + "," + (bottom - this.height) + " ";
        pts += (left + this.width * 3) + "," + bottom;

        return pts;
    }

    private selectCursor(value)
    {
        this.$emit("selectCursor", value);
    }
}
